module.exports = __webpack_public_path__ + "img/about-3.ba9a638d.png";